import React from "react";
import { Modal } from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";

import classes from "./EditChannel.scss";
import EditChannelComp from "./components";
import { useState } from "react";

const styles = {
  modalBody: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    overflowY: "auto",
  },
};

const EditChannel = props => {
  const {
    onCloseModal,
    chatId,
    channelLabel,
    channelDescription,
    channelProfileImage,
  } = props;

  const { t } = useI18n(["common"]);
  const [isUploading, setIsUploading] = useState(false);

  return (
    <EditChannelComp
      chatId={chatId}
      onClose={onCloseModal}
      channelLabel={channelLabel}
      channelDescription={channelDescription}
      channelProfileImage={channelProfileImage}
    >
      <Modal width="600px" height="675px" onClose={onCloseModal}>
        <Modal.Header title={t("common:edit_channel_information")} />
        <Modal.Body style={styles.modalBody}>
          <div className={classes.profileImageContainer}>
            <EditChannelComp.ProfileImage uploadStatus={setIsUploading} />
          </div>
          <EditChannelComp.Name />
          <EditChannelComp.Description />
        </Modal.Body>
        <Modal.Footer hasSeparator>
          <EditChannelComp.Submit
            onClose={onCloseModal}
            isUploading={isUploading}
          />
        </Modal.Footer>
      </Modal>
    </EditChannelComp>
  );
};

export default EditChannel;
